import { filterComparison } from './constants';

export const getFilterOptions = (filterTypes, filterBy) => {
    return filterComparison.filter((filter) =>
        filterTypes
            .find((filterType) => filterType.name === filterBy)
            .comparisonFilter.includes(filter.name),
    );
};
